import React from 'react'
import styled from 'styled-components'
import SingleBlogCategoryItem from './SingleBlogCategoryItem'

const StyledList = styled.ul`
  display: none;

  ${({ theme }) => theme.media.desktop} {
    display: flex;
    margin-top: 64px;
    margin-bottom: 64px;
  }
`
const BlogCategoryList = ({ data, current }) => (
  <StyledList>
    {data
      .filter(({ node }) => node.icon)
      .map(category => (
        <SingleBlogCategoryItem
          singleCategory={current}
          current={current === category.node.slug}
          key={category.node.id}
          data={category.node}
        />
      ))}
  </StyledList>
)

export default BlogCategoryList
